import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: 18px;
`;

export const LabelContent = styled.div`
  display: flex;
`;

export const Label = styled.p`
  color: gray;
  margin-right: 8px;
  font-size: 14px;
`;

export const CollboratorEmail = styled.label`
  margin-left: 8px;
`;